

import React, { useState } from "react";
import { FilterMode } from "./Filter";
import BasicGrid from "./Grid";
import { message } from "antd";
import { expiryApproveApi } from "../../../services/nearToExpiry";
import { useNearToExpiryStore } from "../../../store/useNearToExpiryStore";

const NearToExpiryListForApprove = () => {
  const [gridData, setGridData] = useState([]);
  const [lastSearchPayload, setLastSearchPayload] = useState(null);

  const { getListForApprove } = useNearToExpiryStore();

  const handleApprove = async () => {
    const approvedItems = gridData
      .filter((row) => row.isChecked)
      .map((row) => ({
        id: row.ID,
        approvedQuantity: Number(row.ScanQty),
      }));

    if (approvedItems.length === 0) {
      message.warning("Please select items and enter Scan Qty");
      return;
    }

    try {
      await expiryApproveApi(approvedItems);
      message.success("Approved successfully");

      if (lastSearchPayload) {
        await getListForApprove(lastSearchPayload);
      }
    } catch (err) {
      message.error("Approval failed");
    }
  };

  return (
    <>
      <FilterMode
        onApprove={handleApprove}
        onSearchPayload={setLastSearchPayload}
      />
      <BasicGrid gridData={gridData} setGridData={setGridData} />
    </>
  );
};

export default NearToExpiryListForApprove;
